// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rating {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 90px;
    padding-left: 15px;
    padding-right: 15px;
    color: var(--text);
}

#rating-message {
    max-width: 100%;
    width: 300px;
    height: 168px;
    resize: none;
    border-color: #5D5757;
    color: var(--filter);
    background-color: var(--form-background);
    font-size: 14px;
    color: var(--text);
    background-color: var(--form-background);
}

#rating-message::placeholder {
    width: 264px;
    max-width: 100%;
    color: var(--filter);
}

.success-text {
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    margin-left: 5px;
}

.rating-text {
    margin-left: 5px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
}

.action-text {
    font-size: 20px;
    font-weight: 700;
}

.text-padding {
    padding-top: 50px;
}

.rating-titles {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 90%;
    flex-wrap: wrap;
}

.btn-reform {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    max-width: 282px;
    height: 40px;
    margin-bottom: 20px;
    background-color: var(--primary-background) !important;
    color: var(--primary-font);
    border-radius: 80px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
}
@media (min-width:1400px) {
  .croqui-avaliacao{
    opacity: 100% !important;
  }
}

@media (min-width:767px) {

  .croqui-avaliacao{
    display: flex;
    position: fixed;
    width: 100%;
    height: 90%;
    justify-content: center;
    background-image: url("/assets/svg/avaliacao/croqui-avaliacao.png");
    background-position: left bottom;
    background-repeat: no-repeat;
    background-size: auto 70%;
    opacity: 50%;
    z-index: -1;
  }

  .container-rating{
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;

  }

  .rating{
    max-width: 71%;
  }


    .rating-titles {
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .success-text {
        font-size: 24px;
    }

    .rating-text {
        font-size: 16px;
    }

    .text-padding {
        padding-top: 15px;
    }

    #rating-message {
        width: 480px;
        height: 70px;
    }

    #rating-message::placeholder {
        width: 500px;
    }

    .action-text {
        font-size: 24px;
        margin-top: 90px;
    }

    .btn-reform {
        max-width: 354px;
        height: 47px;
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/contato/avaliacao/avaliacao.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,sDAAsD;IACtD,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mEAAmE;IACnE,gCAAgC;IAChC,4BAA4B;IAC5B,yBAAyB;IACzB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;;EAEzB;;EAEA;IACE,cAAc;EAChB;;;IAGE;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".rating {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 90px;\n    padding-left: 15px;\n    padding-right: 15px;\n    color: var(--text);\n}\n\n#rating-message {\n    max-width: 100%;\n    width: 300px;\n    height: 168px;\n    resize: none;\n    border-color: #5D5757;\n    color: var(--filter);\n    background-color: var(--form-background);\n    font-size: 14px;\n    color: var(--text);\n    background-color: var(--form-background);\n}\n\n#rating-message::placeholder {\n    width: 264px;\n    max-width: 100%;\n    color: var(--filter);\n}\n\n.success-text {\n    font-size: 16px;\n    font-weight: 700;\n    text-align: center;\n    margin-left: 5px;\n}\n\n.rating-text {\n    margin-left: 5px;\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n}\n\n.action-text {\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.text-padding {\n    padding-top: 50px;\n}\n\n.rating-titles {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 90%;\n    flex-wrap: wrap;\n}\n\n.btn-reform {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n    max-width: 282px;\n    height: 40px;\n    margin-bottom: 20px;\n    background-color: var(--primary-background) !important;\n    color: var(--primary-font);\n    border-radius: 80px;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 500;\n}\n@media (min-width:1400px) {\n  .croqui-avaliacao{\n    opacity: 100% !important;\n  }\n}\n\n@media (min-width:767px) {\n\n  .croqui-avaliacao{\n    display: flex;\n    position: fixed;\n    width: 100%;\n    height: 90%;\n    justify-content: center;\n    background-image: url(\"/assets/svg/avaliacao/croqui-avaliacao.png\");\n    background-position: left bottom;\n    background-repeat: no-repeat;\n    background-size: auto 70%;\n    opacity: 50%;\n    z-index: -1;\n  }\n\n  .container-rating{\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n\n  }\n\n  .rating{\n    max-width: 71%;\n  }\n\n\n    .rating-titles {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n    }\n\n    .success-text {\n        font-size: 24px;\n    }\n\n    .rating-text {\n        font-size: 16px;\n    }\n\n    .text-padding {\n        padding-top: 15px;\n    }\n\n    #rating-message {\n        width: 480px;\n        height: 70px;\n    }\n\n    #rating-message::placeholder {\n        width: 500px;\n    }\n\n    .action-text {\n        font-size: 24px;\n        margin-top: 90px;\n    }\n\n    .btn-reform {\n        max-width: 354px;\n        height: 47px;\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
